<script setup>
defineProps({
  details: {
    type: Array,
    default: () => [],
  },
  backgroundColor: {
    type: String,
    default: () => '',
  },
});
</script>

<template>
  <div class="insurance-program__details">
    <div
      v-for="(group, groupIndex) in details"
      :key="groupIndex"
      :class="[
        'insurance-program__details-group',
        backgroundColor === 'black' ? 'white' : 'black',
      ]"
    >
      <p
        v-if="group.title"
        class="insurance-program__details-group-title h6-mobile"
        v-html="group.title"
      ></p>
      <ul class="m-0 p-0 insurance-program__details-group-items">
        <li
          v-for="(item, itemIndex) in group.items"
          :key="itemIndex"
          class="m-0 insurance-program__details-group-item"
        >
          <span
            class="insurance-program__details-group-item-title body-3-regular"
          >
            {{ item.title }}
            <CIcon
              v-if="item.tooltip"
              v-tooltip="{ value: item.tooltip, escape: false }"
              class="insurance-program__details-group-item-tooltip"
              name="info-filled"
              width="12"
              height="13"
            />
          </span>
          <span
            class="insurance-program__details-group-item-value body-3-bold"
            v-html="item.value"
          ></span>
        </li>
      </ul>
    </div>
  </div>
</template>
<style scoped lang="scss">
.insurance-program {
  &__details {
    $parent: &;
    display: flex;
    flex-direction: column;
    gap: 32px;
    @include media-breakpoint-up(sm) {
      gap: 56px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 56);
    }
    &-group {
      display: flex;
      flex-direction: column;
      gap: 24px;
      @include media-breakpoint-up(sm) {
        gap: 32px;
      }
      @include media-breakpoint-up(xl) {
        @include responsive-spacing(gap, 32);
      }
      &:last-child {
        padding-bottom: 16px;
        @include media-breakpoint-up(xl) {
          @include responsive-spacing(padding-bottom, 16);
        }
      }
      &-title {
        margin: 0;
      }
      &-items {
        display: flex;
        flex-direction: column;
        gap: 16px;
        list-style: none;
        @include media-breakpoint-up(xl) {
          @include responsive-spacing(gap, 16);
        }
      }
      &-item {
        align-items: center;
        border-bottom: 1px solid $divider;
        display: grid;
        gap: 8px;
        grid-template-columns: 1fr;
        padding: 0 0 16px;
        @include media-breakpoint-up(sm) {
          gap: 56px;
          grid-template-columns: 8fr 4fr;
        }
        @include media-breakpoint-up(md) {
          grid-template-columns: 7.8fr 4.2fr;
        }
        @include media-breakpoint-up(xl) {
          @include responsive-spacing(border-bottom-width, 1);
          @include responsive-spacing(gap, 56);
          @include responsive-spacing(padding-bottom, 16);
        }
        &:last-child {
          border-bottom: unset;
          padding: 0;
        }
        &-title {
          display: flex;
          align-items: center;
          gap: 8px;
          max-width: 90%;
          @include media-breakpoint-up(sm) {
            max-width: unset;
          }
          @include media-breakpoint-up(xl) {
            @include responsive-spacing(gap, 8);
          }
        }
        &-tooltip {
          height: 12px;
          width: 12px;
          @include media-breakpoint-up(xl) {
            @include responsive-spacing(height, 12);
            @include responsive-spacing(width, 12);
          }
        }
        &-value {
          max-width: 67%;
          @include media-breakpoint-up(sm) {
            max-width: unset;
          }
        }
      }
    }
  }
}
</style>
